import "./nav.css"

const Title = () => {
    return <>
    <span className="span">Servicios Informáticos Bragado</span>
    <span className="spancelu">Servicios Informáticos<br />Bragado</span>
    </>
}

export default Title